import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNotes: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNotes"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 2.5H20.5V21.5H3.5V16.5H2.5V15H3.5V12.75H2.5V11.25H3.5V9H2.5V7.5H3.5V2.5ZM9 7.5H15V9H9V7.5ZM9 11.25H13V12.75H9V11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNotes;
